import { Component, OnInit } from '@angular/core';
import { AuthService } from 'src/app/shared/services/auth/auth.service';
import { NgForm,FormsModule } from '@angular/forms';
import { Router,NavigationEnd,ActivatedRoute } from '@angular/router';
declare var jQuery: any;
declare var $: any;

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.scss']
})
export class LoginComponent implements OnInit {

  loginRequest: any= {};
  loginError: any;
  loginSuccess: any;

  constructor(
    public authService: AuthService,
    private router: Router,
  ) { }

  ngOnInit() {
    this.loginRequest = {
      devices_id: new Date().getTime(),
      devices_name: navigator.userAgent,
      app_version: 1,
      devices_type: 'Web',
      os: 'Android10',
     devices_token : 'abceajlkdlfka'
    }
  }

  doLogin(form: NgForm) {
    this.authService.registerSuccess = null;
    if (form.valid) {
      // this.loginRequest.email = jQuery("#login_email").val();
      // this.loginRequest.password = jQuery("#login_password").val();
      // //console.log(this.loginRequest.email);
       //console.log(form.value); 
      let request:any = {
       
      };
      request = Object.assign({}, this.loginRequest);

      this.authService.login(request).then(async (_res) => {
        console.log(_res);
            if (_res.status == 0) {

              this.loginError = _res.message;
            } else {
              this.router.navigate(['/shop']);
            }
            
             }).catch((err) => {
              console.log({ err });
              this.loginError =  err;
        });
      }    
  }

}
